<template>
  <div class="p-3" style="font-family: IRANSansX-Regular">
    <div class="row justify-content-center" style="direction: ltr">
      <div class="col-12 col-md-6 m-md-0 order-1">
        <div class="input-group mr-auto mx-auto text-center p-2 location-detail mt-2">
          <div
            style="font-size: 14px; text-align: center; width: 100%; color: #6e6e6e"
            class="mb-2"
          >
            زمان
          </div>
          <div class="input-group">
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="ساعت"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="دقیقه"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="ثانیه"
            />
          </div>
          <div class="input-group">
            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_hour" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_min" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_sec" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 m-md-0 order-2">
        <div class="input-group mr-auto mx-auto text-center p-2 location-detail mt-2">
          <div
            style="font-size: 14px; text-align: center; width: 100%; color: #6e6e6e"
            class="mb-2"
          >
            تاریخ
          </div>
          <div class="input-group">
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="سال"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="ماه"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="روز"
            />
          </div>
          <div class="input-group">
            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_year" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_month" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_day" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-100 m-3"></div>
    <!-- <input class="autocomplete-input" v-model="selectedLocation" disabled /> -->
    <select
      class="autocomplete-input"
      style="font-size: 14px; height: 50px"
      v-model="selectedLocation"
      @change="setPrashnaLocation"
    >
      <!-- <option v-for="location in locations" :value="for i in range(locations.length)">
        {{ getLocationItem(location["properties"]) }}
      </option> -->

      <option v-for="(location, i) in locations" :value="i">
        {{ getLocationItem(location.properties) }}
      </option>

    </select>

    <!-- <div
      class="w-100 p-2 text-right text-md-center text-secondary mt-2"
      dir="rtl"
      style="font-size: 14px"
    >
      موقعیت جغرافیایی پیشفرض در قسمت تنظیمات قابل تغییر است.
    </div> -->
    <div style="width: 300px" class="mr-auto mx-auto"></div>

    <!-- <div class="advanced-area" style="direction: ltr" v-if="is_advance_form"> -->
    <div class="advanced-area" style="direction: ltr">
      <div class="row mt-3">
        <div class="col-12 col-md-6 m-md-0 mb-3">
          <DSTSelector @updateFormDSToffset="updateDSToffset"></DSTSelector>
        </div>

        <div class="col-12 col-md-6 m-md-0 mb-3">
          <div class="input-group mr-auto mx-auto text-center timezone">
            <select
              disabled="disabled"
              class="form-control p-0 m-0"
              style="
                width: 40px;
                text-align: center;
                border: none;
                background: transparent;
                direction: ltr;
              "

            >
              <option selected="selected" style="text-align: center">{{timezone}}</option>
            </select>
            <span
              class="input-group-text border-0"
              style="background: transparent; font-size: 12px"
              >منطقه&zwnj;زمانی</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 m-3"></div>

    <div class="w-100 m-3"></div>

    <div class="container text-center mb-2">
      <div @click="submitChart()" class="calculate-btn mr-auto mx-auto">محاسبه پرشنا</div>
    </div>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import ApiService from "../service/api";
import DSTSelector from "./DSTSelector.vue";
import TimezoneSelector from "./TimezoneSelector.vue";

import HelperLib from "./helper";
import Loading from "./Loading.vue";

import moment from "jalali-moment";
export default {
  name: "ChartFormPrashnaFree",
  components: {
    Loading,
    DatePicker,
    Autocomplete,
    // TimezoneSelector,
    DSTSelector,
    TimePicker,

  },
  props: {},
  data() {
    return {
      locations: [
        {
          geometry: {
            coordinates: [51.3896004, 35.6892523],
            type: "Point",
          },
          type: "Feature",
          properties: {
            osm_type: "R",
            osm_id: 6663864,
            extent: [51.0890493, 35.8284702, 51.6063007, 35.5682071],
            country: "Iran",
            osm_key: "place",
            countrycode: "IR",
            osm_value: "city",
            name: "Tehran",
            county: "Tehran County",
            state: "Tehran Province",
            type: "city",
            code: "IDT",
            timezone: "+03:30",
          },
        },
        {
          geometry: {
            coordinates: [-0.12765, 51.5073359],
            type: "Point",
          },
          type: "Feature",
          properties: {
            osm_type: "R",
            osm_id: 65606,
            extent: [-0.5103751, 51.6918741, 0.3340155, 51.2867601],
            country: "United Kingdom",
            osm_key: "place",
            countrycode: "GB",
            osm_value: "city",
            name: "London",
            county: "Greater London",
            state: "England",
            type: "city",
            timezone: "+01:00",
            code: "MDT",
          },
        },
        {
          geometry: {
            coordinates: [-74.0060152, 40.7127281],
            type: "Point",
          },
          type: "Feature",
          properties: {
            osm_type: "R",
            osm_id: 175905,
            extent: [-74.258843, 40.91763, -73.700233, 40.476578],
            country: "United States",
            osm_key: "place",
            countrycode: "US",
            osm_value: "city",
            name: "New York",
            state: "New York",
            type: "city",
            timezone: "-04:00",
            code: "EDT",
          },
        },
        {
          geometry: {
            coordinates: [-118.242766, 34.0536909],
            type: "Point",
          },
          type: "Feature",
          properties: {
            osm_type: "R",
            osm_id: 207359,
            extent: [-118.6681779, 34.337306, -118.1552947, 33.659541],
            country: "United States",
            osm_key: "place",
            countrycode: "US",
            osm_value: "city",
            name: "Los Angeles",
            county: "Los Angeles County",
            state: "California",
            type: "city",
            timezone: "-07:00",
            code: "PDT",
          },
        },
        {
          geometry: {
            coordinates: [151.2082848, -33.8698439],
            type: "Point",
          },
          type: "Feature",
          properties: {
            osm_type: "R",
            osm_id: 5750005,
            extent: [150.260825, -33.3641864, 151.343898, -34.1732416],
            country: "Australia",
            osm_key: "place",
            countrycode: "AU",
            osm_value: "city",
            name: "Sydney",
            state: "New South Wales",
            type: "city",
            timezone: "+10:00",
            code: "EAST",
          },
        },
        {
          geometry: {
            coordinates: [-79.3839347, 43.6534817],
            type: "Point",
          },
          type: "Feature",
          properties: {
            osm_type: "R",
            osm_id: 324211,
            extent: [-79.6392727, 43.8554414, -79.1132193, 43.5796082],
            country: "Canada",
            osm_key: "place",
            countrycode: "CA",
            osm_value: "city",
            name: "Toronto",
            county: "Golden Horseshoe",
            state: "Ontario",
            type: "city",
            timezone: "-04:00",
            code: "EDT",
          },
        },
        {
          geometry: {
            coordinates: [-123.113952, 49.2608724],
            type: "Point",
          },
          type: "Feature",
          properties: {
            osm_type: "R",
            osm_id: 1852574,
            extent: [-123.2249611, 49.3161714, -123.0232419, 49.1989306],
            country: "Canada",
            osm_key: "place",
            countrycode: "CA",
            osm_value: "city",
            name: "Vancouver",
            county: "Metro Vancouver Regional District",
            state: "British Columbia",
            type: "city",
            timezone: "-07:00",
            code: "PDT",
          },
        },
      ],
      isLoading: false,
      now_year: null,
      now_month: null,
      now_day: null,
      now_hour: null,
      now_min: null,
      now_sec: null,
      now_timezone: null,
      timezone: "+03:30",
      country: "Iran",
      city: "Tehran",
      state: "Tehran Province",
      selectedLocation: "0",
      isloading: false,
      dst_hour: 0,
      dst_min: 0,
      longitude: 51.3896,
      latitude: 35.6893,
      datepicker_column: {
        576: 1, // under 576px, column count is 1
        992: 2, // under 992px, column count is 2
      },
      chart_result: Object,
    };
  },
  created() {
    this.isLoading = true;

    const now = moment().utcOffset(this.timezone);
    // const timezoneOffset = now.format("Z");
    this.now_year = now.format("jYYYY");
    this.now_month = now.format("jMM");
    this.now_day = now.format("jDD");
    this.now_hour = now.format("HH");
    this.now_min = now.format("mm");
    this.now_sec = now.format("ss");
    this.isLoading = false;

    this.submitChart();

    setInterval(this.updateTime, 1000);
  },
  mounted() {},
  watch: {},
  methods: {
    formatOffset(offset) {
      const regex = /^([+-])(\d{1,2}):(\d{2})$/;
      const match = offset.match(regex);

      if (!match) {
        throw new Error("Invalid timezone string format");
      }

      const sign = match[1] === "+" ? 1 : -1;
      const hours = parseInt(match[2], 10);
      const minutes = parseInt(match[3], 10);

      return sign * (hours + minutes / 60);
    },
    setLocation(location) {
      // console.log(location);
      this.longitude = location["geometry"]["coordinates"][0];
      this.latitude = location["geometry"]["coordinates"][1];
      // this.location.selectedLocation["properties"]["timezone"];
      this.city = location["properties"]["name"];
      this.state = location["properties"]["state"];
      this.country = location["properties"]["country"];
    },
    setPrashnaLocation() {
      // this.timezone = this.selectedLocation;
      const location = this.locations[this.selectedLocation];
      // console.log(location)
      this.timezone = location.properties.timezone;
      // console.log(this.selectedLocation)
      this.longitude = location["geometry"]["coordinates"][0];
      this.latitude = location["geometry"]["coordinates"][1];
      // this.location.selectedLocation["properties"]["timezone"];
      this.city = location["properties"]["name"];
      this.state = location["properties"]["state"];
      this.country = location["properties"]["country"];
      const now = moment().utcOffset(this.timezone);
      // const timezoneOffset = now.format("Z");
      this.now_year = now.format("jYYYY");
      this.now_month = now.format("jMM");
      this.now_day = now.format("jDD");
      this.now_hour = now.format("HH");
      this.now_min = now.format("mm");
      this.now_sec = now.format("ss");
    },
    getLocationItem(item) {
      return `${item["country"]} - ${item["state"]} - ${item["name"]}`;
    },
    handlerNearestTimezone() {
      let request = {
        latitude: this.latitude,
        longitude: this.longitude,
      };

      ApiService.getNearestTimezone(request).then((response) => {
        this.now_timezone = response["data"][1];
      });
    },
    updateTime() {
      // const tz = this.timezone ? this.timezone : this.now_timezone;
      const now = moment().utcOffset(this.timezone);
      // const timezoneOffset = now.format("Z");
      // const formattedTime = now.format("jYYYY-jMM-jDD HH:mm:ss");
      this.now_year = now.format("jYYYY");
      this.now_month = now.format("jMM");
      this.now_day = now.format("jDD");
      this.now_hour = now.format("HH");
      this.now_min = now.format("mm");
      this.now_sec = now.format("ss");
      // this.now_timezone = timezoneOffset;

      // this.currentTime = `${formattedTime} (${tz})`;
    },
    getRange(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i.toString());
      }
      return result;
    },
    updateDSToffset(dst_value) {
      if (dst_value == 0) {
        this.dst_hour = "0";
        this.dst_min = "0";
      }
      if (dst_value == 1) {
        this.dst_hour = "0";
        this.dst_min = "30";
      }
      if (dst_value == 2) {
        this.dst_hour = "1";
        this.dst_min = "0";
      }
      if (dst_value == 3) {
        this.dst_hour = "1";
        this.dst_min = "30";
      }
      if (dst_value == 4) {
        this.dst_hour = "2";
        this.dst_min = "0";
      }
    },

    submitChart() {
      const request = {
        latitude: this.latitude,
        longitude: this.longitude,
        city: this.city,
        state: this.state,
        country: this.country,
        year: this.now_year,
        month: this.now_month,
        day: this.now_day,
        hour: this.now_hour,
        min: this.now_min,
        sec: this.now_sec,
        timezone: this.timezone,
        dst_hour: this.dst_hour,
        dst_min: this.dst_min,
      };

      this.isLoading = true;
      ApiService.getFreePrashna(request).then((response) => {
        // this.chart_result = response["data"];
        this.$emit("appViewUpdateData", response["data"]);
        this.isLoading = false;
      });
      // }
    },
  },
};
</script>

<style scoped>
.autocomplete-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  background-color: #eee;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px);
  background-size: 20px;
  text-align: center;
}

.autocomplete-input:focus,
.autocomplete-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.autocomplete-input::placeholder {
  font-size: 16px;
}

[data-position="below"] .autocomplete-input[aria-expanded="true"] {
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
}

[data-position="above"] .autocomplete-input[aria-expanded="true"] {
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  z-index: 2;
}

.autocomplete[data-loading="true"]:after {
  content: "";
  border: 3px solid rgba(0, 0, 0, 0.12);
  border-right-color: rgba(0, 0, 0, 0.48);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  animation: rotate 1s linear infinite;
}

.autocomplete-result-list {
  font-size: 16px;
  margin: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0;
  box-sizing: border-box;
  max-height: 296px;
  overflow-y: auto;
  background: #fff;
  list-style: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

[data-position="below"] .autocomplete-result-list {
  margin-top: -1px;
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  padding-bottom: 8px;
}

[data-position="above"] .autocomplete-result-list {
  margin-bottom: -1px;
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
  padding-top: 8px;
}

.autocomplete-result {
  font-size: 16px;
  cursor: default;
  padding: 12px 48px 12px 12px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px);
}

.autocomplete-result:hover,
.autocomplete-result[aria-selected="true"] {
  background-color: rgba(0, 0, 0, 0.06);
}

@keyframes rotate {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(359deg);
  }
}
.h-input-group {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
  outline: none;
}
.h-input-wrapper {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 100%;
  box-sizing: border-box;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.h-input {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: transparent;
  border-style: none;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  text-align: center;
}

.h-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(128 189 255 / 50%);
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.h-input-picker {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: white;
  border: 1px solid #ccc;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  padding: 7px;
  border-radius: 5px;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
  text-align: center;
}

.h-input-picker-wrapper {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
}

.h-error {
  width: 100%;
  font-size: 12px;
  color: red;
}
</style>

<style scoped>
.chart-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  text-align: center;
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: right;
  margin: 0;
}

.chart-input:focus,
.chart-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.chart-datepicker {
  border: none;
  padding: none;
  margin: none;
  width: 100%;
}

.chart-datepicker > input {
  background: #eee;
}

.chart-datetime {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2FsZW5kYXItY2hlY2siIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTEwLjg1NCA3LjE0NmEuNS41IDAgMCAxIDAgLjcwOGwtMyAzYS41LjUgMCAwIDEtLjcwOCAwbC0xLjUtMS41YS41LjUgMCAxIDEgLjcwOC0uNzA4TDcuNSA5Ljc5M2wyLjY0Ni0yLjY0N2EuNS41IDAgMCAxIC43MDggMHoiLz4KICA8cGF0aCBkPSJNMy41IDBhLjUuNSAwIDAgMSAuNS41VjFoOFYuNWEuNS41IDAgMCAxIDEgMFYxaDFhMiAyIDAgMCAxIDIgMnYxMWEyIDIgMCAwIDEtMiAySDJhMiAyIDAgMCAxLTItMlYzYTIgMiAwIDAgMSAyLTJoMVYuNWEuNS41IDAgMCAxIC41LS41ek0xIDR2MTBhMSAxIDAgMCAwIDEgMWgxMmExIDEgMCAwIDAgMS0xVjRIMXoiLz4KPC9zdmc+);
  background-position: calc(100% - 10px);
  text-align: center;
}

.chart-title {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaW5wdXQtY3Vyc29yLXRleHQiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNSAyYS41LjUgMCAwIDEgLjUtLjVjLjg2MiAwIDEuNTczLjI4NyAyLjA2LjU2Ni4xNzQuMDk5LjMyMS4xOTguNDQuMjg2LjExOS0uMDg4LjI2Ni0uMTg3LjQ0LS4yODZBNC4xNjUgNC4xNjUgMCAwIDEgMTAuNSAxLjVhLjUuNSAwIDAgMSAwIDFjLS42MzggMC0xLjE3Ny4yMTMtMS41NjQuNDM0YTMuNDkgMy40OSAwIDAgMC0uNDM2LjI5NFY3LjVIOWEuNS41IDAgMCAxIDAgMWgtLjV2NC4yNzJjLjEuMDguMjQ4LjE4Ny40MzYuMjk0LjM4Ny4yMjEuOTI2LjQzNCAxLjU2NC40MzRhLjUuNSAwIDAgMSAwIDEgNC4xNjUgNC4xNjUgMCAwIDEtMi4wNi0uNTY2QTQuNTYxIDQuNTYxIDAgMCAxIDggMTMuNjVhNC41NjEgNC41NjEgMCAwIDEtLjQ0LjI4NSA0LjE2NSA0LjE2NSAwIDAgMS0yLjA2LjU2Ni41LjUgMCAwIDEgMC0xYy42MzggMCAxLjE3Ny0uMjEzIDEuNTY0LS40MzQuMTg4LS4xMDcuMzM1LS4yMTQuNDM2LS4yOTRWOC41SDdhLjUuNSAwIDAgMSAwLTFoLjVWMy4yMjhhMy40OSAzLjQ5IDAgMCAwLS40MzYtLjI5NEEzLjE2NiAzLjE2NiAwIDAgMCA1LjUgMi41LjUuNSAwIDAgMSA1IDJ6Ii8+CiAgPHBhdGggZD0iTTEwIDVoNGExIDEgMCAwIDEgMSAxdjRhMSAxIDAgMCAxLTEgMWgtNHYxaDRhMiAyIDAgMCAwIDItMlY2YTIgMiAwIDAgMC0yLTJoLTR2MXpNNiA1VjRIMmEyIDIgMCAwIDAtMiAydjRhMiAyIDAgMCAwIDIgMmg0di0xSDJhMSAxIDAgMCAxLTEtMVY2YTEgMSAwIDAgMSAxLTFoNHoiLz4KPC9zdmc+);
  background-position: calc(100% - 10px);
  text-align: center;
  background-size: 20px;
  height: 55px;
}

.chart-form {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.save-btn {
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  padding-right: 20px;
  padding-left: 20px;
  width: fit-content;
  color: #fff;
  border: 1px #ccc solid;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #339966;
  outline: none;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
  background: no-repeat
  url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3C!--! Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M433.1 129.1l-83.9-83.9C342.3 38.32 327.1 32 316.1 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9C448 152.9 441.7 137.7 433.1 129.1zM224 416c-35.34 0-64-28.66-64-64s28.66-64 64-64s64 28.66 64 64S259.3 416 224 416zM320 208C320 216.8 312.8 224 304 224h-224C71.16 224 64 216.8 64 208v-96C64 103.2 71.16 96 80 96h224C312.8 96 320 103.2 320 112V208z'/%3E%3C/svg%3E");
}

.calculate-btn {
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  padding-right: 20px;
  padding-left: 20px;
  width: fit-content;
  color: #fff;
  border: 1px #ccc solid;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #339966;
  outline: none;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.calculate-btn:hover {
  transition: all 1s;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
}

.gender-input {
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iNTEyLjAwMDAwMHB0IiBoZWlnaHQ9IjUxMi4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDUxMi4wMDAwMDAgNTEyLjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgoKPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsNTEyLjAwMDAwMCkgc2NhbGUoMC4xMDAwMDAsLTAuMTAwMDAwKSIKZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSJub25lIj4KPHBhdGggZD0iTTQwNDAgNDk2NSBsMCAtMTU1IDE3NiAtMiAxNzYgLTMgLTMzOCAtMzIwIGMtMTg1IC0xNzYgLTM0MSAtMzIxCi0zNDUgLTMyMyAtNCAtMiAtNDMgMjYgLTg2IDYzIC0xODggMTYxIC0zODAgMjU1IC02MjQgMzA2IC0xNDYgMzAgLTM3MiAzMQotNTE2IDAgLTM3MCAtNzggLTY3OCAtMjg5IC04NzMgLTU5OCBsLTQ1IC03MCAtMTMwIC02IGMtMzAwIC0xNCAtNTU4IC0xMTYKLTgwMSAtMzE3IC0zMjMgLTI2OCAtNTA3IC03MjEgLTQ2NCAtMTE0NCA1MSAtNDk5IDM1NSAtOTE2IDgxMiAtMTExMiA5MyAtNDAKMjMwIC03OSAzMTMgLTg5IGw1NSAtNyAwIC0yMDkgMCAtMjA5IC0yMzUgMCAtMjM1IDAgMCAtMTYwIDAgLTE2MCAyMzUgMCAyMzUKMCAwIC0yMjUgMCAtMjI1IDE1NSAwIDE1NSAwIDAgMjI1IDAgMjI1IDI0NSAwIDI0NSAwIDAgMTYwIDAgMTYwIC0yNDUgMCAtMjQ1CjAgMiAyMDcgMyAyMDcgODUgMTYgYzM3NSA3MyA2OTEgMjg3IDg4OSA2MDMgbDQzIDY3IDY3IDAgYzQ5NyAwIDk2OSAyOTYgMTE5NQo3NDggMTg4IDM3NiAxODYgODIzIC01IDEyMDQgLTIyIDQzIC0zOSA3OSAtMzkgODEgMCAyIDE2NSAxNjEgMzY4IDM1MyBsMzY3CjM0OSA1IC0xOTAgNSAtMTkwIDE1NSAwIDE1NSAwIDMgNDQ4IDIgNDQ3IC00NjAgMCAtNDYwIDAgMCAtMTU1eiBtLTEwNTUgLTc1MApjMzQ1IC05NCA2MDggLTMzMCA3MjQgLTY1MiA0OSAtMTMzIDY0IC0yMzggNTggLTM5MyAtNCAtMTA1IC0xMSAtMTU1IC0zMQotMjI1IC0zMiAtMTA3IC04OSAtMjMxIC0xNDcgLTMxNyAtNjMgLTkzIC0yMDIgLTIyNSAtMzAzIC0yODcgLTEzMiAtODIgLTMzNQotMTUxIC00NDMgLTE1MSAtMzMgMCAtMzUgMSAtMjggMjcgMjMgOTIgMjkgMTU2IDMwIDMwMyAwIDE3OSAtMTkgMjk1IC03MiA0NDQKLTEzMiAzNjkgLTQxNiA2NjMgLTc4MCA4MDYgbC05NCAzNyAyNyAzNCBjMTYwIDE5OCAzNjYgMzI4IDYwNCAzODAgMTA3IDI0CjM1OSAyMCA0NTUgLTZ6IG0tMTU0OSAtNjgwIGMtMjEgLTU2IC0zOCAtMjUxIC0zMyAtMzgwIDEzIC0zMDkgMTE3IC01NzMgMzIxCi04MTcgMTM0IC0xNjEgMzgxIC0zMzAgNTc0IC0zOTMgbDUyIC0xNyAtNDggLTYxIGMtMTczIC0yMTggLTQ1NyAtMzU5IC03NTIKLTM3NCAtNDkwIC0yNCAtOTEwIDI5MiAtMTA0NyA3ODcgLTE0IDUyIC0xOCAxMDIgLTE3IDI0NSAwIDE2NiAyIDE4NyAyOCAyNzAKNTggMTkzIDE0NiAzMzYgMjkxIDQ3MyA1MiA0OSAxMjkgMTA5IDE3NiAxMzcgMTIxIDcyIDMwNSAxMzEgNDQ4IDE0NCA4IDEgMTEKLTUgNyAtMTR6IG00NTYgLTYxIGM4MCAtMzAgMjE3IC0xMTQgMjk0IC0xODEgMTMyIC0xMTIgMjY2IC0zMjggMzE0IC01MDMgMjkKLTExMSA0MiAtMjUzIDMwIC0zNjEgLTEyIC0xMjAgLTMwIC0yMDAgLTQ3IC0yMDYgLTggLTMgLTQyIDUgLTc2IDE3IC0zNTQgMTI4Ci02MDYgNDE5IC02NzggNzg1IC0yMCAxMDEgLTE4IDMwMiA1IDQwMCAxMCA0NCAyMCA4MyAyMiA4NyA1IDggNDUgLTMgMTM2IC0zOHoiLz4KPC9nPgo8L3N2Zz4K);
}

.gender-box {
  direction: rtl;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  width: 100%;
  font-size: 16px;
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-x: calc(100% - 10px);
  padding: 12px 48px 12px 12px;
  text-align: center;
  height: 55px;
  margin: 0px;
}

.input-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
}

.location-detail {
  text-align: center;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  font-size: 16px;
  text-align: center;
  margin: 0px;
  height: auto;
}

.timezone {
  text-align: center;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  font-size: 14px;
  background-repeat: no-repeat;
  background-image: url(data:image/svg+xml;base64,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);
  background-size: 20px;
  background-position: 94%;
  padding: 5px 48px 5px 12px;
  text-align: center;
  margin: 0px;
  height: 45px;
}
</style>
